import { useQuery } from "@tanstack/react-query";
import { getAllCustomer } from "../api/customer";
import { GetMemberParams } from "../types/types";
const useGetAllCustomer = ({
  page,
  searchKey,
  area,
  sort,
  limit,
}: GetMemberParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["AllCustomer"],
    queryFn: () => getAllCustomer({ page, searchKey, area, sort, limit }),
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isSuccess };
};

export default useGetAllCustomer;
